import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "../style/components/adminPanel.module.css";
import Modal from "./Modal";

const AdminPanel = () => {
  const [videos, setVideos] = useState([]);
  const [editingVideo, setEditingVideo] = useState(null);
  const [editedTitle, setEditedTitle] = useState("");
  const [editedDescription, setEditedDescription] = useState("");

  const [editedPrice, setEditedPrice] = useState("");

  const fetchVideos = async () => {
    try {
      const res = await axios.get("https://rishat-tour.ru/api/videos");
      setVideos(res.data);
    } catch (err) {
      console.error("Ошибка загрузки видео:", err.message);
    }
  };

  useEffect(() => {
    fetchVideos();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("Удалить это видео?")) {
      try {
        await axios.delete(`https://rishat-tour.ru/api/videos/${id}`);
        setVideos((prev) => prev.filter((v) => v._id !== id));
      } catch (e) {
        console.error("Ошибка удаления:", e.message);
      }
    }
  };

  const startEdit = (video) => {
    setEditingVideo(video);
    setEditedTitle(video.title);
    setEditedDescription(video.description);
  };

  const handleEditSubmit = async () => {
    try {
      const res = await axios.put(
        `https://rishat-tour.ru/api/videos/${editingVideo._id}`,
        {
          title: editedTitle,
          description: editedDescription,
          
    price: Number(editedPrice), 
        }
      );
      setVideos((prev) =>
        prev.map((v) => (v._id === res.data._id ? res.data : v))
      );
      setEditingVideo(null);
    } catch (err) {
      console.error("Ошибка обновления:", err.message);
    }
  };


  return (
    <div className={styles.panel}>
      <h2>Админ-панель</h2>
      <ul className={styles.videoList}>
        {videos.map((video) => (
          <li key={video._id} className={styles.videoItem}>
            <img src={video.posterUrl} alt={video.title} />
            <div className={styles.videoInfo}>
              <h3>{video.title}</h3>
              <p>{video.description}</p>
              <p><strong>Цена:</strong> {video.price ?? '—'}₽</p>

              <button onClick={() => startEdit(video)}>Редактировать</button>
              <button onClick={() => handleDelete(video._id)}>Удалить</button>
            </div>
          </li>
        ))}
      </ul>

      {editingVideo && (
        <Modal>
        <div className={styles.modal}>
          <h3>Редактировать видео</h3>
          <input
            value={editedTitle}
            onChange={(e) => setEditedTitle(e.target.value)}
            placeholder="Заголовок"
          />
          <input
            type="number"
            value={editedPrice}
            onChange={(e) => setEditedPrice(e.target.value)}
            placeholder="Цена (₽)"
            min="0"
          />

          <textarea
            value={editedDescription}
            onChange={(e) => setEditedDescription(e.target.value)}
            placeholder="Описание"
          />
          <button onClick={handleEditSubmit}>Сохранить</button>
          <button onClick={() => setEditingVideo(null)}>Отмена</button>
        </div>
         </Modal>
      )}
    </div>
  );
};

export default AdminPanel;
